/**
 * SmartChoice Public API
 *
 * Exports for consumers of the SmartChoice hook system
 */

// Main hook
export { useSmartChoice } from './useSmartChoice';

// Types for consumers
export type {
  SmartChoiceEligibility,
  SmartChoiceFlags,
} from './smartChoice.config';

// Export COVERAGE_TYPE_RULES for useWidgetSmartChoice
export { COVERAGE_TYPE_RULES } from './smartChoice.config';
